import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiurl = "https://api.stockastix.com";

export const fetchWatchlist = createAsyncThunk(
  "watchlist/fetchWatchlist",
  async (_, { getState, rejectWithValue }) => {
    const token = getState()?.auth?.accessToken;
    try {
      const response = await axios.get(`${apiurl}/watchlist/getwatchlist`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue("Failed to fetch watchlist.");
    }
  }
);

export const addToWatchlist = createAsyncThunk(
  "watchlist/addToWatchlist",
  async (tickerSymbol, { getState, rejectWithValue }) => {
    const token = getState()?.auth?.accessToken;
    try {
      const response = await axios.post(
        `${apiurl}/watchlist/addtowatchlist/`,
        { ticker_symbol: tickerSymbol },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { ticker: tickerSymbol, message: response.data.message };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue("Failed to add to watchlist.");
    }
  }
);


export const deleteWatchlistItem = createAsyncThunk(
  "watchlist/deleteWatchlistItem",
  async (ticker, { getState, rejectWithValue }) => {
    const token = getState()?.auth?.accessToken;
    try {
      const response = await axios.delete(
        `https://api.stockastix.com/watchlist/deletewatchlistitem/?ticker=${ticker}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue("Failed to delete watchlist item.");
    }
  }
);

const watchlistSlice = createSlice({
  name: "watchlist",
  initialState: {
    stocks: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWatchlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWatchlist.fulfilled, (state, action) => {
        state.loading = false;
        state.stocks = action.payload.watchlist;
      })
      .addCase(fetchWatchlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(deleteWatchlistItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteWatchlistItem.fulfilled, (state, action) => {
        state.loading = false;
        state.stocks = state.stocks.filter(
          (item) => item.ticker !== action.payload.ticker
        );
      })
      .addCase(deleteWatchlistItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addToWatchlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToWatchlist.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addToWatchlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default watchlistSlice.reducer;
